import React, { useState, useEffect } from "react";
import { makeStyles, ThemeProvider } from "@material-ui/core/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Typography,
  Paper,
  useMediaQuery,
} from "@material-ui/core";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import { styles } from "./CultivationArticlesTable.styles";
import { theme } from "./Cultivation.theme";
import { cultivations } from "../../utils/newApi";
import AddCultivationTypeWindow from "../../components/ModalWindows/AddCultivationTypeWindow";
import EditCultivatonTypeWindow from "../../components/ModalWindows/EditCultivationTypeWindow";
import { Hidden } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import ErrorSnackBar from "../../components/Snackbar/ErrorSnackBar";
import TablePagination from "@material-ui/core/TablePagination";
import TablePaginationActions from "../../components/common/pagination/TablePaginationActions";
import CommonModal from "../../components/common/modals/CommonModal";
import DeleteEditButton from "../../components/common/buttons/DeleteEditButton";
import ListHeader from "../../components/common/ListHeader";

import {
  SERVER_ERROR_MESSAGES,
  COMMON_MODAL_TEXTS,
  HARVEST_MESSAGES,
} from "../../constants/dictionary";

const useStyles = makeStyles(styles);

const TypesTable = () => {
  const [open, setOpen] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [reload, setReload] = useState(false);
  const [current, setCurrent] = useState({});
  const [types, setTypes] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(false);
  const [errorText, setErrorText] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isExpanded, setIsExpanded] = useState([]);

  const classes = useStyles();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const toggleOpen = () => setOpen(!open);
  const toggleOpenEdit = () => setOpenEdit(!openEdit);
  const toggleOpenDelete = () => setOpenDelete(!openDelete);

  const handleError = (text) => {
    setError(true);
    setErrorText(text);
  };

  const handleAdd = (payload) => {
    cultivations.types
      .add(payload)
      .then(() => setReload(!reload))
      .catch(() => {
        handleError(SERVER_ERROR_MESSAGES.COULD_NOT_ADD_CROP);
      });
  };

  const handleEdit = (id, data) => {
    cultivations.types
      .edit(id, data)
      .then(() => setReload(!reload))
      .catch((err) => {
        handleError(SERVER_ERROR_MESSAGES.COULD_NOT_EDIT_CROP);
      });
  };

  const handleDelete = () => {
    cultivations.types
      .delete(current.id)
      .then(() => setReload(!reload))
      .catch((err) => {
        handleError(SERVER_ERROR_MESSAGES.COULD_NOT_DELETE_CROP);
      });
  };

  const getAreaString = (lower, upper) => {
    if ((lower === null || lower === 0) && (upper === null || lower === 0))
      return "-";
    if (lower && upper === null) return `powyżej ${lower}`;
    if ((lower === null || lower === 0) && upper) return `do ${upper}`;
    return `${lower} - ${upper}`;
  };

  const expand = (index) => {
    let isExpandedCopy = [...isExpanded];
    isExpandedCopy[index] = !isExpandedCopy[index];

    setIsExpanded(isExpandedCopy);
  };

  useEffect(() => {
    cultivations.types
      .all()
      .then((res) => {
        const sorted = res.data ? res.data.sort((a, b) => b.id - a.id) : [];
        setTypes(sorted);
        setIsLoaded(true);

        res.data.forEach(() => setIsExpanded((prev) => [...prev, false]));
      })
      .catch((err) => {
        handleError(SERVER_ERROR_MESSAGES.COULD_NOT_DOWNLOAD_CROPS);
      });

    return setIsExpanded([]);
  }, [reload]);

  return (
    <ThemeProvider theme={theme}>
      {isLoaded ? (
        <TableContainer component={Paper}>
          <ListHeader
            variant="title-add"
            title="Typy upraw"
            handleAdd={toggleOpen}
          />
          <Table>
            <TableHead>
              <TableCell className={classes.value}>{"Nazwa uprawy"}</TableCell>
              <TableCell className={classes.value} />
              <TableCell className={classes.value} />
              <TableCell className={classes.value} />
              <TableCell className={classes.value} />
              <TableCell className={classes.value} />
            </TableHead>

            <TableBody>
              {types
                ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                ?.map((item, index) => (
                  <React.Fragment key={item.id}>
                    <TableRow>
                      <TableCell align="left">
                        <Grid
                          container
                          justifyContent={matches && "center"}
                          alignItems="center"
                          spacing={2}
                        >
                          <Grid
                            item
                            xs={matches ? 12 : 8}
                            align={matches ? "center" : "left"}
                            className={matches && classes.breakline}
                          >
                            <Typography
                              style={{
                                fontFamily: "Montserrat",
                                fontWeight: "bold",
                                wordBreak: "break-word",
                                width: "40vw",
                                maxWidth: "40vw",
                              }}
                            >
                              {item.name}
                            </Typography>
                          </Grid>
                          {matches && (
                            <DeleteEditButton
                              mobile={true}
                              editClickHandler={(e) => {
                                e.stopPropagation();
                                setCurrent(item);
                                toggleOpenEdit();
                              }}
                              deleteClickHandler={(e) => {
                                e.stopPropagation();
                                setCurrent(item);
                                toggleOpenDelete();
                              }}
                            />
                          )}
                        </Grid>
                      </TableCell>

                      <TableCell className={classes.cell} />
                      <TableCell className={classes.cell} />
                      <TableCell className={classes.cell} />
                      <Hidden mdUp>
                        <TableCell className={classes.cell} />
                      </Hidden>

                      {!matches && (
                        <DeleteEditButton
                          mobile={false}
                          editClickHandler={(e) => {
                            e.stopPropagation();
                            setCurrent(item);
                            toggleOpenEdit();
                          }}
                          deleteClickHandler={(e) => {
                            e.stopPropagation();
                            setCurrent(item);
                            toggleOpenDelete();
                          }}
                        />
                      )}

                      <TableCell>
                        {isExpanded[index] ? (
                          <ArrowUpwardIcon
                            onClick={() => expand(index)}
                            color={"secondary"}
                            style={{
                              border: "2px solid black",
                              borderRadius: "15px",
                              cursor: "pointer",
                            }}
                          />
                        ) : (
                          <ArrowDownwardIcon
                            onClick={() => expand(index)}
                            color={"primary"}
                            style={{
                              border: "2px solid black",
                              borderRadius: "15px",
                              cursor: "pointer",
                            }}
                          />
                        )}
                      </TableCell>
                    </TableRow>

                    {isExpanded[index] && (
                      <TableRow>
                        <TableCell className={classes.value}>
                          {"Zalecana ilość uli"}
                        </TableCell>
                        <TableCell className={classes.value}>
                          {"Ilość drzew"}
                        </TableCell>
                        <TableCell className={classes.value}>
                          {"Typ zbioru"}
                        </TableCell>

                        <TableCell className={classes.value} />
                        <TableCell className={classes.value} />
                        <TableCell className={classes.value} />
                      </TableRow>
                    )}

                    {isExpanded[index] &&
                      item?.hiveAmountConfigDAOList.map((config) => (
                        <TableRow>
                          <TableCell className={classes.cell}>
                            {config.suggestedHivesCount}
                          </TableCell>

                          <TableCell className={classes.cell}>
                            {getAreaString(
                              config.lowerTreeDensityRate,
                              config.upperTreeDensityRate
                            )}
                          </TableCell>
                          <TableCell className={classes.cell}>
                            {HARVEST_MESSAGES[config.isHarvestManual]}
                          </TableCell>
                          <TableCell className={classes.cell} />
                          <TableCell className={classes.cell} />
                          <TableCell className={classes.cell} />
                        </TableRow>
                      ))}
                  </React.Fragment>
                ))}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[10, 15, 20, 50]}
            component="div"
            count={types?.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            ActionsComponent={TablePaginationActions}
            style={{
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
            }}
            classes={{
              toolbar: classes.toolbar,
              caption: classes.caption,
            }}
            labelRowsPerPage={"Ilość wierszy na stronę"}
            labelDisplayedRows={({ from, to, count }) => {
              return `${from}–${to} z ${
                count !== -1 ? count : `więcej niż ${to}`
              }`;
            }}
          />
        </TableContainer>
      ) : (
        <div className={classes.container}>
          <CircularProgress color="secondary" className={classes.loader} />
        </div>
      )}
      <ErrorSnackBar
        open={error}
        text={errorText}
        close={() => setError(false)}
      />

      <AddCultivationTypeWindow
        handleAdd={handleAdd}
        open={open}
        toggleOpen={toggleOpen}
        handleError={handleError}
      />
      <CommonModal
        open={openDelete}
        toggleOpen={toggleOpenDelete}
        handleConfirmation={handleDelete}
        title={COMMON_MODAL_TEXTS.FIELD_TYPE_TITLE}
        content={COMMON_MODAL_TEXTS.GENERAL_CONTENT}
      />
      <EditCultivatonTypeWindow
        handleEdit={handleEdit}
        open={openEdit}
        toggleOpen={toggleOpenEdit}
        handleError={handleError}
        current={current}
      />
    </ThemeProvider>
  );
};

export default TypesTable;
